import { useMutation, useQueryClient } from '@tanstack/react-query'
import irisApi from '../lib/api'
import type { UploadSession } from '../types'

interface SaveProgressParams {
  uploaderEmail?: string
  uploaderName?: string
}

function simulateDemoSaveProgress(
  queryClient: ReturnType<typeof useQueryClient>,
  token: string,
): Promise<UploadSession> {
  return new Promise((resolve, reject) => {
    const session = queryClient.getQueryData<UploadSession>(['upload-session', token])
    if (!session) return reject(new Error('No session'))
    setTimeout(() => resolve(session), 400)
  })
}

export function useSaveProgress(token: string, isDemo = false) {
  const queryClient = useQueryClient()

  return useMutation<UploadSession, Error, SaveProgressParams>({
    mutationFn: async ({ uploaderEmail, uploaderName }) => {
      if (isDemo) return simulateDemoSaveProgress(queryClient, token)
      const res = await irisApi.post(`/${token}/save-progress/`, {
        uploader_email: uploaderEmail || undefined,
        uploader_name: uploaderName || undefined,
      })
      return res.data
    },
    onSuccess: () => {
      if (!isDemo) {
        queryClient.invalidateQueries({ queryKey: ['upload-session', token] })
      }
    },
  })
}
